import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePostRequest } from "../../services/PostTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import LiquidationSubDetailsForm from "./LiquidationSubDetailsForm";

function Liquidation() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [productColl, setproductColl] = useState([]);
    const [branch, setBranch] = useState([]);
    const [LiquidationData, setLiquidationData] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState(null);
    const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
    const [liquidationStatus, setLiquidationStatus] = useState(false);
    const [transHeadId, settransHeadId] = useState([]);

    const getBranch = async () => {
        setloading(true);
        const response = await handleGetRequest("zbizgateway/lov/lovBranch");
        setBranch(response?.data);
        setloading(false);
    };

    useEffect(() => {
        getBranch();
    }, []);

    const getProductColl = async () => {
        setloading(true);
        const response = await handleGetRequest("zbizgateway/lov/lovProductCollection");
        setproductColl(response?.data);
        setloading(false);
    };

    useEffect(() => {
        getProductColl();
    }, []);

    const handleAddNewSubDetails = (e, status) => {
        e.preventDefault();
        setLiquidationStatus(status);
        setDisplaySubDetailsModal(true);
    };
    const onRowSelect = (event) => {
        settransHeadId([event?.data?.transHeadId]);
    };

    const formik = useFormik({
        initialValues: {
            branchId: "",
            chqNo: null,
            invoiceNo: null,
            amount: null,
            productCollCode: "",
        },
        validate: (data) => {
            let errors = {};

            // if (!data.branchId) {
            //     errors.branchId = "This field is required.";
            // } will use in future
            if (!data.productCollCode) {
                errors.productCollCode = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["branchId"] = data?.branchId?.id;
            data["productCollCode"] = data?.productCollCode?.code;
            const lodegmentArray = await handlePostRequest(data, "zbizgateway/fin/collection/fetchLiquidationChq");
            setLiquidationData(lodegmentArray.data);
            // getBranch();
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Liquidation</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="baseLocationId" className={classNames({ "p-error": isFormFieldValid("baseLocationId") }, "Label__Text")}>
                                    Branch Code<span className="Label__Required">*</span>
                                </label>
                                <Dropdown id="branchId" placeholder="Select branch" options={branch} optionLabel="description" name="branchId" value={formik.values.branchId} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("branchId") }, "Dropdown__Round")} />
                                {getFormErrorMessage("branchId")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="chqNo" className={classNames({ "p-error": isFormFieldValid("chqNo") }, "Label__Text")}>
                                    Cheque No.
                                </label>
                                <InputText id="chqNo" placeholder="Enter cheque no" name="chqNo" value={formik.values.chqNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("chqNo") }, "Input__Round")} />

                                {getFormErrorMessage("chqNo")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="invoiceNo" className={classNames({ "p-error": isFormFieldValid("invoiceNo") }, "Label__Text")}>
                                    Deposit Slip No.
                                </label>
                                <InputText id="invoiceNo" placeholder="Enter deposit slip no" name="invoiceNo" value={formik.values.invoiceNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("invoiceNo") }, "Input__Round")} />

                                {getFormErrorMessage("invoiceNo")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="amount" className={classNames({ "p-error": isFormFieldValid("amount") }, "Label__Text")}>
                                    Amount
                                </label>
                                <InputText id="amount" placeholder="Enter amount" name="amount" value={formik.values.amount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("amount") }, "Input__Round")} />

                                {getFormErrorMessage("amount")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="productCollCode" className={classNames({ "p-error": isFormFieldValid("productCollCode") }, "Label__Text")}>
                                    Product Collection<span className="Label__Required">*</span>
                                </label>

                                <Dropdown
                                    id="productCollCode"
                                    placeholder="Select product collection"
                                    options={productColl}
                                    optionLabel="description"
                                    name="productCollCode"
                                    value={formik.values.productCollCode}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("productCollCode") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("productCollCode")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label="Fetch" className="Btn__Dark" />
                    </div>
                </form>
            </div>

            <div className="card p-datatable-sm">
                <DataTable header="" loading={loading} onRowSelect={onRowSelect} value={LiquidationData} selection={selectedCustomers} onSelectionChange={(e) => setSelectedCustomers(e.value)} paginator rows={6} emptyMessage="No data found.">
                    <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
                    <Column field="companyName" header="Company Name" />
                    <Column field="branchName" header="Branch Name" />
                    <Column field="bankName" header="Bank Name" />
                    <Column field="depositSlipNo" header="Deposit Slip No." />
                    <Column field="chqNo" header="Cheque No." />
                    <Column field="chqDate" header="Cheque Date" />
                    <Column field="depositSlipAmount" header="Amount" />
                    <Column field="department" header="Clearing Date" />
                    <Column field="department" header="Liquidation/Rej" />
                    <Column field="department" header="Reason" />
                    <Column field="department" header="Status" />
                </DataTable>
            </div>
            <br />
            <div className="Down__Btn">
                <Button label="Reject" className="Btn__Transparent" onClick={(e) => handleAddNewSubDetails(e, "R")} />
                <Button disabled={loading} onClick={(e) => handleAddNewSubDetails(e, "A")} label="Approve" className="Btn__Dark" />
            </div>
            <Dialog visible={displaySubDetailsModal} style={{ width: "50vw" }} onHide={() => setDisplaySubDetailsModal(false)}>
                <LiquidationSubDetailsForm liquidationStatus={liquidationStatus} transHeadId={transHeadId} />
            </Dialog>
        </>
    );
}

export default Liquidation;
